module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 var response = content.response 
__p+=' ';
 var productSuggestions =
content.productSuggestions 
__p+=' ';
 var querySuggestions = content.querySuggestions

__p+=' ';
 var searchPageResults = content.searchPageResults 
__p+=' ';
 var
productResultsNumber = content.productResultsNumber 
__p+=' ';
 var queryResultsNumber
= content.queryResultsNumber 
__p+=' ';
 var searchUrl = content.searchUrl 
__p+=' ';
 var
searchQuery = content.searchQuery 
__p+='\n\n<div id="predictive-search-results" role="listbox">\n  <div\n    id="predictive-search-results-groups-wrapper"\n    class="predictive-search__results-groups-wrapper"\n  >\n    ';
 if (querySuggestions && querySuggestions.length >= 1) { 
__p+='\n    <div class="predictive-search-queries">\n      <h3\n        id="predictive-search-queries"\n        class="predictive-search__heading title-font-11"\n      >\n        Suggested Searches\n      </h3>\n      <ul\n        id="predictive-search-results-queries-list"\n        class="predictive-search__results-list"\n        role="group"\n        aria-labelledby="predictive-search-queries"\n      >\n        ';
 $(querySuggestions).each(function() { 
__p+='\n        <li\n          id="predictive-search-option-query"\n          class="predictive-search__list-item"\n          role="option"\n          aria-selected="false"\n        >\n          <a\n            href="'+
((__t=( this.url ))==null?'':__t)+
'"\n            class="predictive-search__item link body-font-1"\n            tabindex="-1"\n          >\n            <div class="predictive-search__item-content">\n              <p\n                class="predictive-search__item-heading predictive-search__item-query-result"\n              >\n                '+
((__t=( this.text ))==null?'':__t)+
'\n              </p>\n            </div>\n          </a>\n        </li>\n        ';
 }) 
__p+='\n      </ul>\n      <div class="search-summary">\n        <p>\n          '+
((__t=( productResultsNumber ))==null?'':__t)+
' Product Results for\n          <span class="search-query">"'+
((__t=( searchQuery))==null?'':__t)+
'"</span>\n        </p>\n        ';
 if (productResultsNumber >= 1) { 
__p+='\n        <a class="cta-font-1" href="'+
((__t=( content.searchUrl))==null?'':__t)+
'"\n          >View<span id="dash"></span>All</a\n        >\n        ';
 } 
__p+='\n      </div>\n    </div>\n    ';
 } 
__p+=' ';
 if (queryResultsNumber == 0) { 
__p+='\n    <div class="search-summary no-queries">\n      <p>\n        '+
((__t=( productResultsNumber ))==null?'':__t)+
' Product Results for\n        <span class="search-query">"'+
((__t=( searchQuery))==null?'':__t)+
'"</span>\n      </p>\n      ';
 if (productResultsNumber >= 1) { 
__p+='\n      <a class="cta-font-1" href="'+
((__t=( content.searchUrl))==null?'':__t)+
'"\n        >View<span id="dash"></span>All</a\n      >\n      ';
 } 
__p+='\n    </div>\n    ';
 } 
__p+=' ';
 if (productSuggestions && productSuggestions.length >= 1) { 
__p+='\n    <div class="predictive-search-products">\n      <h3 id="predictive-search-products" class="predictive-search__heading">\n        Products\n      </h3>\n      <ul\n        id="predictive-search-results-products-list"\n        class="predictive-search__results-list"\n        role="group"\n        aria-labelledby="predictive-search-products"\n      >\n        ';
 $(productSuggestions).each(function() { 
__p+='\n        <li\n          id="predictive-search-option-product"\n          class="predictive-search__list-item"\n          role="option"\n          aria-selected="false"\n        >\n          <a\n            href="'+
((__t=( this.url ))==null?'':__t)+
'"\n            class="predictive-search__item link"\n            tabindex="-1"\n          >\n            <div class="predictive-search__item-content">\n              <img\n                class="predictive-search__image"\n                src="'+
((__t=(this.featured_image.url ))==null?'':__t)+
'"\n                alt="'+
((__t=(this.featured_image.alt ))==null?'':__t)+
'"\n                width="50"\n                height="50"\n              />\n            </div>\n            <div class="predictive-search__item-content">\n              <p\n                class="predictive-search__item-heading predictive-search__item-product-result title title-font-11"\n              >\n                '+
((__t=( this.title ))==null?'':__t)+
'\n              </p>\n              <p\n                class="predictive-search__item-product-result price body-font-3"\n              >\n                Starting at '+
((__t=( this.price ))==null?'':__t)+
'\n              </p>\n            </div>\n          </a>\n        </li>\n        ';
 }) 
__p+='\n      </ul>\n    </div>\n    ';
 } 
__p+='\n  </div>\n</div>\n';
}
return __p;
};
